type FeatureFlags = "useMocks" | "newProductCreate" | "newTableView" | "newSandboxExperience" | "newDashboard";

function getFeatureFlag(flag: FeatureFlags) {
  // Set Feature Flag if this is a Vercel preview and it hasn't been set
  if (window.location.hostname.includes("vercel.app") && localStorage.getItem(flag) === null) {
    localStorage.setItem(flag, "true");
  }
  return localStorage.getItem(flag) === "true";
}

export const featureFlags: Record<FeatureFlags, boolean> = {
  useMocks: getFeatureFlag("useMocks"),
  newProductCreate: true,
  newTableView: getFeatureFlag("newTableView"),
  newSandboxExperience: getFeatureFlag("newSandboxExperience"),
  newDashboard: getFeatureFlag("newDashboard"),
};
